// extracted by mini-css-extract-plugin
export default {"contanier":"patient_contanier__dZEgx","overlay":"patient_overlay__9L1GU","img":"patient_img__tsRwn","formBody":"patient_formBody__zWBfQ"};